<template>
  <div>
     <!-- redirecionar para a C:\EmEstudo\projetos\Confrariati1\site\index.html -->
   <LoguinPrincipal msg="Bem vindo a Confraria de TI 2025 segundo teste 4"/>
  </div>
  

  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <HelloWorld msg="Bem vindo a Confraria de TI 2025 segundo teste 4"/> -->

</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import LoguinPrincipal from './components/LoguinPrincipal.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    LoguinPrincipal
  },
  mounted() {
    // Redireciona para o arquivo index.html especificado
    //window.location.href = 'file:///C:/EmEstudo/projetos/Confrariati1/site/index.html';
    // Se estiver rodando em um servidor, use o caminho HTTP/HTTPS
    //  window.location.href = 'http://localhost:porta/caminho/index.html';
    //  window.location.href = '/site/index.html';
    if (window.location.pathname === '/') {
      window.location.href = '/site/index.html'
    }
  }
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
